import { I18n } from 'aws-amplify';
import './ProjectProfileManagement.css';
import LoadingPanel from '../common/LoadingPanel';
import { Button, FormControl, MenuItem, Select, TextField } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Utils from '@/common/utils/utils';
import Constant from '../../common/constant/Constant';
import { useSnackbar } from 'notistack';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { closeTabId, panelInitDataAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector, setPanelSelector, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import { corporationAtom } from '@/state/atom/corporationAtom';

import { projectInuseDetailAtom, projectListInCorporationAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import {
    onChangeProjectName, changeProjectName, getValueProjectServiceType, onChangeProjectServiceType, onSubmitChangeProjectProfile, validateInputProjectProfile,
    handleCancelEditProjectProfile, getStatusUsingSynonymProject, getStatusUsingIpAddressRestrictProject, getIpAddressRangeProject, onChangeUsingIpAddressRestrict,
    onChangeIpAddressRange, changeIpAddressRange, getProjectOfEmailResponseSetting
} from '@/component/project/handler/ProjectProfileManagementHandler';
import EmailResponseSetting from './EmailResponseSetting/EmailResponseSetting';
import { getPublicAPI } from '@/service/publicService';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';

export default function ProjectProfileManagement(props) {
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const corporationDetail = useRecoilValue(corporationAtom);
    const userDetail = useRecoilValue(userAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [listProjectInCorp, setListProjectInCorp] = useRecoilState(projectListInCorporationAtom);
    const [listProjectOfUser, setListProjectOfUser] = useRecoilState(projectListInCorporationByUserIdAtom);

    let currentProjectNameObject = Utils.convertJSONDataToObject(projectInuseDetail?.name);
    let currentProjectName = currentProjectNameObject ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentProjectNameObject) : '';
    const [projectName, setProjectName] = useState(currentProjectName);
    const [projectType, setProjectType] = useState(getValueProjectServiceType(projectInuseDetail));
    const [usingSynonym, setUsingSynonym] = useState(getStatusUsingSynonymProject(projectInuseDetail));
    const [usingIpAddressRestrict, setUsingIpAddressRestrict] = useState(getStatusUsingIpAddressRestrictProject(projectInuseDetail));
    const [ipAddressRange, setIpAddressRange] = useState(getIpAddressRangeProject(projectInuseDetail));
    const ipAddressRangeDefault = useMemo(() => {
        return getIpAddressRangeProject(projectInuseDetail);
    }, [projectInuseDetail]);
    
    const [isEmailResponseSettingFunction, setIsEmailResponseSettingFunction] = useState(false)
    const [projectMail, setProjectMail] = useState({value: '', error: ''})
    const [mailSettingDefault, setMailSettingDefault] = useState({
        projectMail: '',
        projectAddressName: '',
        senderEmailAddress: '',
        ccEmailAddressList: [],
        bccEmailAddressList: [],
        signature: ''
    });
    const [projectAddressName, setProjectAddressName] = useState({value: '', error: ''})
    const [senderEmailAddress, setSenderEmailAddress] = useState({value: '', error: ''})
    const [ccEmailAddressList, setCcEmailAddressList] = useState([])
    const [bccEmailAddressList, setBccEmailAddressList] = useState([])
    const [signature, setSignature] = useState({value: '', error: ''})

    const [listSuggestSearchEmail, setListSuggestSearchEmail] = useState([])
    const [isSendEmailVerify, setIsSendEmailVerify] = useState(false)

    const [isLoading, setIsLoading] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [isShowDialogReload, setIsShowDialogReload] = useState(false);
    const [isOpenConfirmReset, setIsOpenConfirmReset] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState({});

    // handle init get emailResponseSettingData & listSuggestSearchEmail
    useEffect(() => {
        if (!isDisplayEmailResponseSetting()) return;
        // only query when init projectType = deskOnPublicOn or change projectType = deskOnPublicOn
        (async () => {
            try {
                setIsLoading(true);

                let params = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_EMAIL_SETTING,
                    projectId: projectInuseDetail.id,
                    corporationId: corporationDetail.id
                };
            
                let result = await getPublicAPI(props?.API, params);
                if (result.success) {
                    const {projectDetail, suggestList} = Utils.convertJSONDataToObject(result.payload);
                    
                    const {
                        isEmailResponseSettingFunction: getIsEmailSetting,
                        projectMail: getProjectMail,
                        projectAddressName: getProjectAddressName,
                        senderEmailAddress: getSenderEmailAddress,
                        ccEmailAddressList: getCcEmailAddressList,
                        bccEmailAddressList: getBccEmailAddressList,
                        signature: getSignature
                    } = getProjectOfEmailResponseSetting(projectDetail, corporationDetail)

                    setIsEmailResponseSettingFunction(getIsEmailSetting)
                    setProjectMail(getProjectMail)
                    setProjectAddressName(getProjectAddressName)
                    setSenderEmailAddress(getSenderEmailAddress)
                    setCcEmailAddressList(getCcEmailAddressList)
                    setBccEmailAddressList(getBccEmailAddressList)
                    setSignature(getSignature)
                    setMailSettingDefault({
                        projectMail: getProjectMail.value,
                        projectAddressName: getProjectAddressName.value,
                        senderEmailAddress: getSenderEmailAddress.value,
                        signature: getSignature.value,
                        ccEmailAddressList: getCcEmailAddressList,
                        bccEmailAddressList: getBccEmailAddressList
                    });
                    
                    setListSuggestSearchEmail([...suggestList])
                }
            } catch (err) {
                console.log('GET_PROJECT_EMAIL_SETTING  err :>>', err);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [projectType])

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isEdited) {
                setIsConfirmCancelTabs(true);
            } else {
                closePanelTab({
                    event: null,
                    panelType: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
    }, [isEdited])

    useEffect(() => {
        /**
         * restore corporation ip address range. when usingIpAddressRestrict = off
         */
        const currentIpsRangeOfProjectInuse = getIpAddressRangeProject(projectInuseDetail);
        if (!Utils.isEmptyString(currentIpsRangeOfProjectInuse) && !usingIpAddressRestrict) {
            setIpAddressRange(currentIpsRangeOfProjectInuse);
        }
        
    }, [usingIpAddressRestrict]);

    const enabledIframeLinkEmbed = () => {
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)) {
            return false;
        }

        let deskService = corporationDetail?.deskService;
        let publicWebForm = corporationDetail?.limitValue?.publicWebForm;

        // if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)) {
        //     const inviterSetting = Utils.convertJSONDataToObject(
        //         corporationDetail?.inviterSetting
        //     );
        //     deskService = inviterSetting.deskService;
        //     publicWebForm = inviterSetting.publicWebForm;
        // }

        return Boolean(Utils.isPublicDesk(projectInuseDetail) && deskService && publicWebForm);
    }

    const isDisplayEmailResponseSetting = () => {
        if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
            const corpLimitValue = corporationDetail?.limitValue;
            const emailResponseFunction = corpLimitValue?.emailResponseFunction || Constant.STATUS_SERVICE_PERMISSION.OFF;
            const isUsingEmailResponseFunction = emailResponseFunction ? Number(emailResponseFunction) === Constant.STATUS_SERVICE_PERMISSION.ON : false;
    
            return isUsingEmailResponseFunction && Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON === projectType;
        }
        return false;
    }

    const isDisplaySettingSynonymSearch = () => {
        if (corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) return false;

        let synonymSearch = corporationDetail?.limitValue?.synonymSearch;
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)) {
            const inviterSetting = Utils.convertJSONDataToObject(
                corporationDetail?.inviterSetting
            );
            synonymSearch = inviterSetting?.synonymSearch;
        }

        if (synonymSearch) {
            return true;
        }

        return false;
    }

    const handleOpenSettingIframe = () => {
        addNewPanel({
            type: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
            tabId: `${Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_IFRAME}_${projectInuseDetail.id}`,
            projectDetail: { ...projectInuseDetail, name: currentProjectName },
            props
        });
    }

    const enabledIpAddressRestriction = () => {
        return Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON === projectType;
    }

    const onSubmitCancelEditProjectProfile = () => {
        setIsEdited(false);
        setIsLoading(false);
        setProjectName(currentProjectName);
        setProjectType(getValueProjectServiceType(projectInuseDetail));
        setUsingSynonym(getStatusUsingSynonymProject(projectInuseDetail));
        setUsingIpAddressRestrict(getStatusUsingIpAddressRestrictProject(projectInuseDetail));
        setIpAddressRange(getIpAddressRangeProject(projectInuseDetail));
        setError({})

        const {
            isEmailResponseSettingFunction: getIsEmailSetting,
            projectMail: getProjectMail,
            projectAddressName: getProjectAddressName,
            senderEmailAddress: getSenderEmailAddress,
            ccEmailAddressList: getCcEmailAddressList,
            bccEmailAddressList: getBccEmailAddressList,
            signature: getSignature
        } = getProjectOfEmailResponseSetting(projectInuseDetail, corporationDetail)

        setIsEmailResponseSettingFunction(getIsEmailSetting)
        setProjectMail(getProjectMail)
        setProjectAddressName(getProjectAddressName)
        setSenderEmailAddress(getSenderEmailAddress)
        setCcEmailAddressList(getCcEmailAddressList)
        setBccEmailAddressList(getBccEmailAddressList)
        setSignature(getSignature)
    }
    return (
        <div className="aiSetting project-profile-setting">
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <>
                    <div className="groupSetting category-active">
                        {/* <div className="advanced-setting-onoff"> */}
                        {/* <h3>{I18n.get('CM-TITLE-AI-MNG')}</h3> */}
                        <div className="groupBtn">
                            <Button
                                variant="contained"
                                className="btn-hg32 btn-light"
                                color="primary"
                                onClick={() => handleCancelEditProjectProfile(isEdited, setIsOpenConfirmReset, error)}
                                disabled={!isEdited}
                            // disabled={isDisabledBtnCancel()}
                            >
                                {I18n.get('CM-BUTTON-CANCEL')}
                            </Button>

                            <Button
                                onClick={() =>
                                    onSubmitChangeProjectProfile(
                                        setIsLoading,
                                        error,
                                        setError,
                                        projectName,
                                        projectType,
                                        usingSynonym,
                                        usingIpAddressRestrict,
                                        ipAddressRange,
                                        enqueueSnackbar,
                                        userDetail.id,
                                        projectInuseDetail,
                                        setProjectInuseDetail,
                                        setIsShowDialogReload,
                                        listProjectInCorp,
                                        setListProjectInCorp,
                                        listProjectOfUser,
                                        setListProjectOfUser,
                                        setIsEdited,
                                        setIpAddressRange,
                                        setUsingIpAddressRestrict,

                                        isEmailResponseSettingFunction,
                                        setIsEmailResponseSettingFunction,
                                        projectMail,
                                        setProjectMail,
                                        projectAddressName,
                                        setProjectAddressName,
                                        senderEmailAddress,
                                        setSenderEmailAddress,
                                        ccEmailAddressList,
                                        setCcEmailAddressList,
                                        bccEmailAddressList,
                                        setBccEmailAddressList,
                                        signature,
                                        setSignature,
                                        corporationDetail,
                                        reloadTicketListByPanelType,
                                        setIsSendEmailVerify,
                                        setMailSettingDefault,
                                    )
                                }
                                disabled={!(isEdited && validateInputProjectProfile(error, projectType))}
                                variant="contained"
                                className="btn-hg32 btn-primary"
                                color="primary"
                            >
                                {I18n.get('COMBTN011')}
                            </Button>
                        </div>
                        {/* </div> */}
                    </div>

                    <div className="groupSetting category-active">
                        <div className="advanced-setting-title">
                            <h3>{I18n.get('プロジェクト情報')}</h3>
                        </div>
                        <div className="groupSettingContent">
                            <div className="groupSettingItem">
                                <div className="embeddedCode-label margin-bottom-5">
                                    {I18n.get('プロジェクト名')}
                                    <span className="required">*</span>
                                </div>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    className="form-control-wrapInput form-control-hg40"
                                    value={projectName}
                                    onChange={e => onChangeProjectName(e.target.value, setProjectName, setIsEdited)}
                                    onBlur={e =>
                                        changeProjectName(e.target.value, setProjectName, error, setError, setIsEdited)
                                    }
                                    error={error.projectName ? true : false}
                                    helperText={error.projectName}
                                />
                            </div>

                            <div className="groupSettingItem">
                                <div className="embeddedCode-label margin-bottom-5">
                                    {I18n.get('プロジェクトタイプ')}
                                    <span className="required">*</span>
                                </div>

                                <FormControl
                                    variant="outlined"
                                    className="form-control--wrap form-control--hg32"
                                    style={{ textAlign: 'left' }}
                                >
                                    <Select
                                        variant="outlined"
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }}
                                        displayEmpty
                                        defaultValue={projectType}
                                        value={projectType}
                                        onChange={event =>
                                            onChangeProjectServiceType(
                                                event,
                                                projectType,
                                                setProjectType,
                                                setIsEdited
                                            )
                                        }
                                        disabled={[
                                            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                                            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
                                        ].includes(corporationDetail.contractType)}
                                    >
                                        <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_OFF}>
                                            {Constant.PROJECT_SERVICE_TYPE.DESK_OFF}
                                        </MenuItem>
                                        <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}>
                                            {Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}
                                        </MenuItem>
                                        {corporationDetail.deskService ===
                                            Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                <MenuItem
                                                    value={Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON}
                                                >
                                                    {Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON}
                                                </MenuItem>
                                            )}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>

                    {enabledIframeLinkEmbed() && (
                        <div className="groupSetting category-active setting-iframe">
                            <div className="advanced-setting-title">
                                <h3>{I18n.get('LABEL-CONFIG-PUBLIC-WEB-FORM')}</h3>
                            </div>
                            <p className="iframe-link" onClick={() => handleOpenSettingIframe()}>
                                {I18n.get('LABEL-GO-TO-CONFIG-PUBLIC-WEB-FORM')}
                            </p>
                        </div>
                    )}

                    {isDisplayEmailResponseSetting() && (
                        <EmailResponseSetting
                            corporationDetail={corporationDetail}
                            isEmailResponseSettingFunction={isEmailResponseSettingFunction}
                            setIsEmailResponseSettingFunction={setIsEmailResponseSettingFunction}
                            projectMail={projectMail}
                            mailSettingDefault={mailSettingDefault}
                            setProjectMail={setProjectMail}
                            projectAddressName={projectAddressName}
                            setProjectAddressName={setProjectAddressName}
                            senderEmailAddress={senderEmailAddress}
                            setSenderEmailAddress={setSenderEmailAddress}
                            ccEmailAddressList={ccEmailAddressList}
                            setCcEmailAddressList={setCcEmailAddressList}
                            bccEmailAddressList={bccEmailAddressList}
                            setBccEmailAddressList={setBccEmailAddressList}
                            signature={signature}
                            setSignature={setSignature}

                            setIsEdited={setIsEdited}
                            setError={setError}
                            listSuggestSearchEmail={listSuggestSearchEmail}
                        />
                    )}

                    {enabledIpAddressRestriction() && (
                        <div className="groupSetting category-active">
                            <div className="advanced-setting-title">
                                <h3>{I18n.get('IP_ADDRESS_RESTRICT_FOR_PUBLIC_FUNCTION')}</h3>
                            </div>
                            <div className="groupSettingContent setting-synonym">
                                <div className="title-name setting-ai-function">
                                    {I18n.get('APPLY_IP_ADDRESS_RESTRICTION')}
                                </div>
                                <div className="switch-check setting-ai-function">
                                    <input
                                        name="ipaddressRestrict"
                                        id="setting-ipaddress-switch-id"
                                        type="checkbox"
                                        checked={usingIpAddressRestrict}
                                        onChange={e => {
                                            let usingIpAddressRestrictValue = !usingIpAddressRestrict;
                                            onChangeUsingIpAddressRestrict(usingIpAddressRestrictValue, setUsingIpAddressRestrict, error, setError, setIsEdited);
                                            setIpAddressRange(ipAddressRangeDefault);
                                        }}
                                    />
                                    <label htmlFor="setting-ipaddress-switch-id"></label>
                                </div>
                            </div>
                            <div className="groupSettingItem ipaddress-range">
                                <div className="embeddedCode-label margin-bottom-5">
                                    {I18n.get('IP_ADDRESS_SETTING_DESCRIPTION')}
                                </div>
                                <TextField
                                    id={!ipAddressRange && 'ipaddress-placeholder'}
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    minRows={5}
                                    maxRows={5}
                                    className="form-control-wrapInput form-control-hg40"
                                    value={ipAddressRange}
                                    onChange={e => onChangeIpAddressRange(e.target.value, setIpAddressRange, setIsEdited)}
                                    onBlur={e =>
                                        changeIpAddressRange(e.target.value, setIpAddressRange, error, setError, setIsEdited)
                                    }
                                    disabled={!usingIpAddressRestrict}
                                    error={error.ipAddressRange ? true : false}
                                    helperText={error.ipAddressRange}
                                // placeholder={I18n.get('IP_ADDRESS_RANGE_PLACEHOLDER')}
                                />
                            </div>
                        </div>
                    )}

                    {isDisplaySettingSynonymSearch() && (
                        <div className="groupSetting category-active">
                            <div className="advanced-setting-title">
                                <h3>{I18n.get('類義語検索機能')}</h3>
                            </div>

                            <div className="groupSettingContent setting-synonym">
                                <div className="title-name setting-ai-function">
                                    {I18n.get('類義語検索機能を使用する')}
                                </div>

                                <div className="switch-check setting-ai-function">
                                    <input
                                        name="chatAI"
                                        id="setting-synonym-switch-id"
                                        type="checkbox"
                                        checked={usingSynonym}
                                        onChange={e => {
                                            let usingSynonymValue = !usingSynonym;
                                            setUsingSynonym(usingSynonymValue);
                                            setIsEdited(true);
                                        }}
                                    />
                                    <label htmlFor="setting-synonym-switch-id"></label>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            <ConfirmDialog
                isOpen={isOpenConfirmReset}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={() => {
                    setIsOpenConfirmReset(false);
                    onSubmitChangeProjectProfile(
                        setIsLoading,
                        error,
                        setError,
                        projectName,
                        projectType,
                        usingSynonym,
                        usingIpAddressRestrict,
                        ipAddressRange,
                        enqueueSnackbar,
                        userDetail.id,
                        projectInuseDetail,
                        setProjectInuseDetail,
                        setIsShowDialogReload,
                        listProjectInCorp,
                        setListProjectInCorp,
                        listProjectOfUser,
                        setListProjectOfUser,
                        setIsEdited,
                        setIpAddressRange,
                        setUsingIpAddressRestrict,
                        isEmailResponseSettingFunction,
                        setIsEmailResponseSettingFunction,
                        projectMail,
                        setProjectMail,
                        projectAddressName,
                        setProjectAddressName,
                        senderEmailAddress,
                        setSenderEmailAddress,
                        ccEmailAddressList,
                        setCcEmailAddressList,
                        bccEmailAddressList,
                        setBccEmailAddressList,
                        signature,
                        setSignature,
                        corporationDetail,
                        reloadTicketListByPanelType,
                        setIsSendEmailVerify,
                        setMailSettingDefault
                    )
                }
                }
                closeCallBack={() => {
                    onSubmitCancelEditProjectProfile();
                    setIsOpenConfirmReset(false);
                }}
                cancelCallBack={() => {
                    setIsOpenConfirmReset(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />

            <ConfirmDialog
                isOpen={isShowDialogReload}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => {
                    window.location.reload();
                }}
            />

            <ConfirmDialog
                isOpen={isSendEmailVerify}
                msgConfirm={I18n.get('MSG_SEND_VERIFY_EMAIL_CONFIRM')}
                okCallBack={() => setIsSendEmailVerify(false)}
            />

            <ConfirmDialog
                isOpen={isConfirmCancelTabs}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={() => {
                    setIsConfirmCancelTabs(false);
                    onSubmitChangeProjectProfile(
                        setIsLoading,
                        error,
                        setError,
                        projectName,
                        projectType,
                        usingSynonym,
                        usingIpAddressRestrict,
                        ipAddressRange,
                        enqueueSnackbar,
                        userDetail.id,
                        projectInuseDetail,
                        setProjectInuseDetail,
                        setIsShowDialogReload,
                        listProjectInCorp,
                        setListProjectInCorp,
                        listProjectOfUser,
                        setListProjectOfUser,
                        setIsEdited,
                        setIpAddressRange,
                        setUsingIpAddressRestrict,
                        isEmailResponseSettingFunction,
                        setIsEmailResponseSettingFunction,
                        projectMail,
                        setProjectMail,
                        projectAddressName,
                        setProjectAddressName,
                        senderEmailAddress,
                        setSenderEmailAddress,
                        ccEmailAddressList,
                        setCcEmailAddressList,
                        bccEmailAddressList,
                        setBccEmailAddressList,
                        signature,
                        setSignature,
                        corporationDetail,
                        reloadTicketListByPanelType,
                        setIsSendEmailVerify,
                        setMailSettingDefault
                    )
                }
                }
                closeCallBack={() => {
                    setIsConfirmCancelTabs(false);
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                }}
                cancelCallBack={() => {
                    setIsConfirmCancelTabs(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />
        </div>
    );
}
